const Footer = () => {
	return (
		<div
			style={{
				textAlign: "center",
				marginBottom: 10,
			}}
		>
			Made with ♥ by{" "}
			<a
				href=""
				style={{ cursor: "pointer" }}
			>
				AAYUSH JAIN
      </a>
		</div>
	);
};

export default Footer;
